// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dashboard.css - Version améliorée avec cohérence visuelle */
.dashboard {
  /* margin-left: 230px; */
  padding: 2rem;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0e7ff 100%);
  min-height: 100vh;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.dashboard h2 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
  color: #1a202c;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 50%, #3b82f6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.dashboard h2::before {
  content: "📊";
  font-size: 2rem;
  filter: none;
  -webkit-text-fill-color: initial;
  background: none;
}

.dashboard-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-bottom: 3rem;
}

.card {
  flex: 1 1 280px;
  display: flex;
  align-items: center;
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;
}

.card::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  transition: left 0.6s ease;
}

.card:hover::before {
  left: 100%;
}

.card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.card .icon {
  font-size: 2rem;
  margin-right: 1rem;
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);
}

.card:hover .icon {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

.card .icon.total {
  background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);
  font-size: 2rem;
  border-radius: 50%;
}

.card h3 {
  margin: 0 0 0.25rem 0;
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
}

.card p {
  margin: 0;
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.card.blue {
  border-color: rgba(59, 130, 246, 0.2);
}

.card.blue .icon {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
}

.card.blue:hover {
  border-color: rgba(59, 130, 246, 0.4);
  box-shadow: 0 20px 40px rgba(59, 130, 246, 0.2);
}

.card.green {
  border-color: rgba(16, 185, 129, 0.2);
}

.card.green .icon {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.card.green:hover {
  border-color: rgba(16, 185, 129, 0.4);
  box-shadow: 0 20px 40px rgba(16, 185, 129, 0.2);
}

.card.red {
  border-color: rgba(239, 68, 68, 0.2);
}

.card.red .icon {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
}

.card.red:hover {
  border-color: rgba(239, 68, 68, 0.4);
  box-shadow: 0 20px 40px rgba(239, 68, 68, 0.2);
}

/* Section des graphiques */
.charts-section {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  margin-top: 3rem;
  margin-bottom: 3rem;
}

.chart-card {
  flex: 1 1;
  min-width: 300px;
  padding: 2rem;
  background: white;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.chart-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  border-color: rgba(79, 70, 229, 0.2);
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.chart-card h4 {
  color: #1f2937;
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.chart-header select {
  padding: 0.5rem 1rem;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 0.875rem;
  background: white;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 500;
}

.chart-header select:focus {
  outline: none;
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

.chart-header select:hover {
  border-color: #d1d5db;
  transform: translateY(-1px);
}

/* Conteneur Google Maps */
.google-map-container {
  margin: 2rem auto;
  max-width: 1000px;
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.google-map-container:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

/* Responsive */
@media (max-width: 1024px) {
  .dashboard {
    margin-left: 0;
    padding: 1rem;
  }

  .charts-section {
    flex-direction: column;
  }
}

@media (max-width: 768px) {
  .dashboard h2 {
    font-size: 2rem;
  }

  .dashboard-cards {
    flex-direction: column;
    gap: 1rem;
  }

  .card {
    flex: none;
    padding: 1.25rem;
  }

  .card .icon {
    width: 50px;
    height: 50px;
    font-size: 1.5rem;
  }

  .card h3 {
    font-size: 1.5rem;
  }

  .chart-card {
    padding: 1.5rem;
    min-width: auto;
  }

  .chart-header {
    flex-direction: column;
    align-items: stretch;
  }

  .chart-header select {
    align-self: flex-end;
    width: auto;
  }
}

@media (max-width: 480px) {
  .dashboard {
    padding: 0.75rem;
  }

  .dashboard h2 {
    font-size: 1.75rem;
    margin-bottom: 1.5rem;
  }

  .card {
    padding: 1rem;
    flex-direction: column;
    text-align: center;
    gap: 0.75rem;
  }

  .card .icon {
    margin-right: 0;
    width: 60px;
    height: 60px;
  }

  .chart-card {
    padding: 1rem;
  }

  .chart-card h4 {
    font-size: 1rem;
  }
}

/* Animations d'entrée */
.card {
  animation: slideInUp 0.6s ease forwards;
  opacity: 0;
  transform: translateY(30px);
}

.card:nth-child(1) {
  animation-delay: 0.1s;
}
.card:nth-child(2) {
  animation-delay: 0.2s;
}
.card:nth-child(3) {
  animation-delay: 0.3s;
}
.card:nth-child(4) {
  animation-delay: 0.4s;
}
.card:nth-child(5) {
  animation-delay: 0.5s;
}

@keyframes slideInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.chart-card {
  animation: fadeInScale 0.8s ease forwards;
  opacity: 0;
  transform: scale(0.95);
}

.charts-section .chart-card:nth-child(1) {
  animation-delay: 0.6s;
}
.charts-section .chart-card:nth-child(2) {
  animation-delay: 0.8s;
}

@keyframes fadeInScale {
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Amélioration des performances */
.card,
.chart-card,
.card .icon {
  will-change: transform;
}

/* Focus visible pour l'accessibilité */
.chart-header select:focus-visible {
  outline: 2px solid #4f46e5;
  outline-offset: 2px;
}

/* États de chargement */
.card.loading {
  opacity: 0.6;
  pointer-events: none;
}

.card.loading .icon {
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* Scrollbar personnalisée */
.dashboard::-webkit-scrollbar {
  width: 8px;
}

.dashboard::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.dashboard::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #cbd5e1, #94a3b8);
  border-radius: 4px;
}

.dashboard::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #94a3b8, #64748b);
}

/* Dashboard Footer */
.dashboard-footer {
  margin-top: 4rem;
  padding: 2rem;
  text-align: center;
  border-top: 2px solid rgba(79, 70, 229, 0.2);
  background: linear-gradient(135deg, rgba(79, 70, 229, 0.05) 0%, rgba(124, 58, 237, 0.05) 100%);
  border-radius: 12px;
}

.dashboard-footer p {
  margin: 0;
  color: #64748b;
  font-size: 0.875rem;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.dashboard-footer strong {
  color: #4f46e5;
  font-weight: 600;
}

`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D;EACE,wBAAwB;EACxB,aAAa;EACb,6DAA6D;EAC7D,iBAAiB;EACjB,uFAAuF;AACzF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yCAAyC;EACzC,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,yCAAyC;EACzC,yBAAyB;EACzB,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,6DAA6D;EAC7D,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;EAC3C,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA,eAAe;AACf;EACE;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,WAAW;EACb;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,wBAAwB;AACxB;EACE,uCAAuC;EACvC,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,yCAAyC;EACzC,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,kCAAkC;AAClC;;;EAGE,sBAAsB;AACxB;;AAEA,uCAAuC;AACvC;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA,4BAA4B;AAC5B;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;AACvD;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,4CAA4C;EAC5C,8FAA8F;EAC9F,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/* Dashboard.css - Version améliorée avec cohérence visuelle */\n.dashboard {\n  /* margin-left: 230px; */\n  padding: 2rem;\n  background: linear-gradient(135deg, #f0f9ff 0%, #e0e7ff 100%);\n  min-height: 100vh;\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.dashboard h2 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 2rem;\n  color: #1a202c;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 50%, #3b82f6 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.dashboard h2::before {\n  content: \"📊\";\n  font-size: 2rem;\n  filter: none;\n  -webkit-text-fill-color: initial;\n  background: none;\n}\n\n.dashboard-cards {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n  margin-bottom: 3rem;\n}\n\n.card {\n  flex: 1 1 280px;\n  display: flex;\n  align-items: center;\n  background: white;\n  border-radius: 16px;\n  padding: 1.5rem;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n  border: 2px solid transparent;\n  position: relative;\n  overflow: hidden;\n}\n\n.card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);\n  transition: left 0.6s ease;\n}\n\n.card:hover::before {\n  left: 100%;\n}\n\n.card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n}\n\n.card .icon {\n  font-size: 2rem;\n  margin-right: 1rem;\n  width: 60px;\n  height: 60px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  flex-shrink: 0;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  transition: all 0.3s ease;\n  background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);\n}\n\n.card:hover .icon {\n  transform: scale(1.1);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);\n}\n\n.card .icon.total {\n  background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);\n  font-size: 2rem;\n  border-radius: 50%;\n}\n\n.card h3 {\n  margin: 0 0 0.25rem 0;\n  font-size: 2rem;\n  font-weight: 700;\n  color: #1f2937;\n  font-family: \"Monaco\", \"Menlo\", \"Ubuntu Mono\", monospace;\n}\n\n.card p {\n  margin: 0;\n  font-size: 0.875rem;\n  color: #6b7280;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.card.blue {\n  border-color: rgba(59, 130, 246, 0.2);\n}\n\n.card.blue .icon {\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n}\n\n.card.blue:hover {\n  border-color: rgba(59, 130, 246, 0.4);\n  box-shadow: 0 20px 40px rgba(59, 130, 246, 0.2);\n}\n\n.card.green {\n  border-color: rgba(16, 185, 129, 0.2);\n}\n\n.card.green .icon {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n}\n\n.card.green:hover {\n  border-color: rgba(16, 185, 129, 0.4);\n  box-shadow: 0 20px 40px rgba(16, 185, 129, 0.2);\n}\n\n.card.red {\n  border-color: rgba(239, 68, 68, 0.2);\n}\n\n.card.red .icon {\n  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n}\n\n.card.red:hover {\n  border-color: rgba(239, 68, 68, 0.4);\n  box-shadow: 0 20px 40px rgba(239, 68, 68, 0.2);\n}\n\n/* Section des graphiques */\n.charts-section {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2rem;\n  margin-top: 3rem;\n  margin-bottom: 3rem;\n}\n\n.chart-card {\n  flex: 1;\n  min-width: 300px;\n  padding: 2rem;\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n  border: 2px solid transparent;\n}\n\n.chart-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n  border-color: rgba(79, 70, 229, 0.2);\n}\n\n.chart-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.chart-card h4 {\n  color: #1f2937;\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin: 0;\n  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.chart-header select {\n  padding: 0.5rem 1rem;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  background: white;\n  color: #374151;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-weight: 500;\n}\n\n.chart-header select:focus {\n  outline: none;\n  border-color: #4f46e5;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n}\n\n.chart-header select:hover {\n  border-color: #d1d5db;\n  transform: translateY(-1px);\n}\n\n/* Conteneur Google Maps */\n.google-map-container {\n  margin: 2rem auto;\n  max-width: 1000px;\n  background: white;\n  border-radius: 16px;\n  padding: 1.5rem;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n}\n\n.google-map-container:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .dashboard {\n    margin-left: 0;\n    padding: 1rem;\n  }\n\n  .charts-section {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 768px) {\n  .dashboard h2 {\n    font-size: 2rem;\n  }\n\n  .dashboard-cards {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .card {\n    flex: none;\n    padding: 1.25rem;\n  }\n\n  .card .icon {\n    width: 50px;\n    height: 50px;\n    font-size: 1.5rem;\n  }\n\n  .card h3 {\n    font-size: 1.5rem;\n  }\n\n  .chart-card {\n    padding: 1.5rem;\n    min-width: auto;\n  }\n\n  .chart-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .chart-header select {\n    align-self: flex-end;\n    width: auto;\n  }\n}\n\n@media (max-width: 480px) {\n  .dashboard {\n    padding: 0.75rem;\n  }\n\n  .dashboard h2 {\n    font-size: 1.75rem;\n    margin-bottom: 1.5rem;\n  }\n\n  .card {\n    padding: 1rem;\n    flex-direction: column;\n    text-align: center;\n    gap: 0.75rem;\n  }\n\n  .card .icon {\n    margin-right: 0;\n    width: 60px;\n    height: 60px;\n  }\n\n  .chart-card {\n    padding: 1rem;\n  }\n\n  .chart-card h4 {\n    font-size: 1rem;\n  }\n}\n\n/* Animations d'entrée */\n.card {\n  animation: slideInUp 0.6s ease forwards;\n  opacity: 0;\n  transform: translateY(30px);\n}\n\n.card:nth-child(1) {\n  animation-delay: 0.1s;\n}\n.card:nth-child(2) {\n  animation-delay: 0.2s;\n}\n.card:nth-child(3) {\n  animation-delay: 0.3s;\n}\n.card:nth-child(4) {\n  animation-delay: 0.4s;\n}\n.card:nth-child(5) {\n  animation-delay: 0.5s;\n}\n\n@keyframes slideInUp {\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.chart-card {\n  animation: fadeInScale 0.8s ease forwards;\n  opacity: 0;\n  transform: scale(0.95);\n}\n\n.charts-section .chart-card:nth-child(1) {\n  animation-delay: 0.6s;\n}\n.charts-section .chart-card:nth-child(2) {\n  animation-delay: 0.8s;\n}\n\n@keyframes fadeInScale {\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Amélioration des performances */\n.card,\n.chart-card,\n.card .icon {\n  will-change: transform;\n}\n\n/* Focus visible pour l'accessibilité */\n.chart-header select:focus-visible {\n  outline: 2px solid #4f46e5;\n  outline-offset: 2px;\n}\n\n/* États de chargement */\n.card.loading {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.card.loading .icon {\n  animation: pulse 2s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n/* Scrollbar personnalisée */\n.dashboard::-webkit-scrollbar {\n  width: 8px;\n}\n\n.dashboard::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 4px;\n}\n\n.dashboard::-webkit-scrollbar-thumb {\n  background: linear-gradient(135deg, #cbd5e1, #94a3b8);\n  border-radius: 4px;\n}\n\n.dashboard::-webkit-scrollbar-thumb:hover {\n  background: linear-gradient(135deg, #94a3b8, #64748b);\n}\n\n/* Dashboard Footer */\n.dashboard-footer {\n  margin-top: 4rem;\n  padding: 2rem;\n  text-align: center;\n  border-top: 2px solid rgba(79, 70, 229, 0.2);\n  background: linear-gradient(135deg, rgba(79, 70, 229, 0.05) 0%, rgba(124, 58, 237, 0.05) 100%);\n  border-radius: 12px;\n}\n\n.dashboard-footer p {\n  margin: 0;\n  color: #64748b;\n  font-size: 0.875rem;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n}\n\n.dashboard-footer strong {\n  color: #4f46e5;\n  font-weight: 600;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
